import { HttpClient } from '@angular/common/http';
import { environment } from './../../../environments/environment';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  constructor(private _http: HttpClient) { }

  // Función del login
  onLogin(loginForm) {
    return this._http.post(environment.LOGIN, loginForm);
  }

  /**
   * Función que trae las sucursales
   */
  getSucursales() {
    const data = { idsucursal: 0 };
    return this._http.post(environment.seller.SUCURSALES, data);
  }

  /**
   * Consulta al backend si el usuario autenticado (según el token) es administrador
   */
  checkAdmin() {
    return this._http.get(environment.admin.CHECK_ADMIN);
  }
}
